import React, { useEffect, useState } from 'react';
import { Form, InputGroup, Modal } from 'react-bootstrap';
import { FaEye, FaEyeSlash } from "react-icons/fa";

const PasswordModal = (props) => {

    const { pwdError, handlePwdChange, pwdModalShow, handleClose, enteredPassword, handleConfirmPwd } = props;
    const [showPassword, setShowPassword] = useState(false);

useEffect(() => {
  
    if(pwdModalShow ===false){
        setShowPassword(false) 
    }
}, [ pwdModalShow])


    const togglePasswordVisibility = () => {
        setShowPassword(!showPassword);
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        handleConfirmPwd()
      };

    
    return (
        <Modal
            {...props}
            size="md"
            aria-labelledby="contained-modal-title-vcenter"
            backdrop="static"
            centered
            keyboard={false}
            className=""
            show={pwdModalShow}
            onHide={handleClose}
       >

            <div className="d-flex justify-content-end pe-2 pt-2"><button type="button" className="btn-close d-flex justify-content-end" data-bs-dismiss="modal" aria-label="Close" onClick={handleClose} /></div>

            <Modal.Body className="" closeButton >
                <h5 >Please enter your password to continue</h5>
                <Form onSubmit={handleSubmit} id="confrmPassword">
                    <Form.Group className="mb-3 mt-3 gap-2" controlId="exampleForm.ControlInput1">
                        <InputGroup>
                            <Form.Control
                                className="input_email"
                                type={showPassword ? 'text' : 'password'}
                                autoFocus
                                placeholder="Enter your login password"
                                value={enteredPassword}
                                onChange={handlePwdChange}
                            />
                            <InputGroup.Text onClick={togglePasswordVisibility} className='C-pointer'>
                                {showPassword ? <FaEyeSlash /> : <FaEye />}
                            </InputGroup.Text>
                        </InputGroup>
                        {pwdError && <p className='text-danger fs-6'>Incorrect password</p>}
                    </Form.Group>
                </Form>
                <div className="d-flex justify-content-end">
                    {/* <button className='btn btn-secondary py-1' onClick={handleClose}>{"Cancel"}</button> */}
                    <button className='orange_btn py-1' type='sumbit' onClick={handleConfirmPwd}>Confirm</button>
                </div>

            </Modal.Body>


        </Modal>
    );
};

export default PasswordModal;